import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const LanguageActiveSvg = ({ size = 24 }) => (
  <SvgWrapper size={size}>
    <path
      d="M12.2054 20.8696L16.9183 10.0889L21.7706 21.2748"
      stroke="url(#paint0_linear)"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1075 18.8055H20.6987"
      stroke="url(#paint1_linear)"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.46893 9.87492C4.46893 9.87492 6.62444 14.0077 10.3099 15.5797"
      stroke="url(#paint2_linear)"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.25668 15.5787C3.25668 15.5787 8.73458 12.749 10.083 6.50618"
      stroke="url(#paint3_linear)"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.6024 3.31765V5.9237"
      stroke="url(#paint4_linear)"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.50682L11.4747 6.49069"
      stroke="url(#paint5_linear)"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="10.3657"
        y1="7.79858"
        x2="10.3657"
        y2="23.2872"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9FB1E1" />
        <stop offset="1" stopColor="#6679BF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="13.1745"
        y1="17.1848"
        x2="13.1745"
        y2="20.369"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7C8FCC" />
        <stop offset="1" stopColor="#7184C5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="-4.78602"
        y1="4.02225"
        x2="1.10639"
        y2="18.6739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDF2F8" />
        <stop offset="1" stopColor="#C2CFE4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="-7.5596"
        y1="-2.80156"
        x2="3.8404"
        y2="18.0295"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDF2F8" />
        <stop offset="1" stopColor="#C2CFE4" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="-0.154216"
        y1="-0.325381"
        x2="3.25075"
        y2="7.94384"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDF2F8" />
        <stop offset="1" stopColor="#D6DFED" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="-13.8029"
        y1="3.8371"
        x2="-13.3161"
        y2="9.74855"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDF2F8" />
        <stop offset="1" stopColor="#CCD7E9" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
